export const TRIP_LIST_NOTE_MAX_LENGTH = 1500

export function normalizeTripListNote(notes: string | undefined): string | undefined {
  const trimmedNotes = notes?.trim()
  return trimmedNotes || undefined
}
